<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions" v-if="mail_template && can('write_mail_templates')">
      <button class="btn btn-outline-secondary mr-2" @click="preview">{{ 'preview_mail_template' | t }}</button>
      <button class="btn btn-primary" @click="save">
        {{ (mail_template.id ? 'update_mail_template' : 'create_mail_template') | t }}
      </button>
    </div>
    <div v-if="mail_template">
      <mail-templates-images-modal ref="images_modal" v-model="mail_template.images"></mail-templates-images-modal>
      <mail-templates-preview-modal ref="preview_modal"></mail-templates-preview-modal>
      <div class="row">
        <div class="col-8" v-if="current_locale">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <div class="text-left">
                    <h5>{{ getLocaleName(current_locale.locale) }}</h5>
                  </div>
                </div>
                <div class="col text-right">
                  <button
                    class="btn btn-danger btn-sm"
                    @click="deleteCurrentLocale"
                    v-if="mail_template.default_locale != current_locale.locale"
                  >
                    {{ 'delete_translation' | t }}
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <input class="form-control" placeholder="Sender email" v-model="current_locale.sender_mail" /><br />
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <input class="form-control" placeholder="Subject" v-model="current_locale.subject" /><br />
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <vue-ace-editor
                    v-model="current_locale.body"
                    @init="editorInit()"
                    lang="html"
                    theme="chrome"
                    width="100%"
                    :height="editHeight"
                  ></vue-ace-editor>
                  <!--textarea.form-control(rows="40", placeholder="Template content", v-model="current_locale.body")-->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <div class="card">
            <div class="card-body">
              <div class="form-group">
                <h5>{{ 'general' | t }}</h5>
                <div class="form-group">
                  <label>{{ 'name' | t }}</label>
                  <input
                    class="form-control"
                    :placeholder="$i18n.t('mail_template_name')"
                    v-model="mail_template.name"
                  />
                </div>
                <div class="form-group">
                  <label>{{ 'Images' }}</label>
                  <p>
                    <button class="btn btn-sm btn-outline-primary" @click="$refs.images_modal.open()">
                      {{ 'manage_images' | t }}
                    </button>
                  </p>
                  <p class="text-muted">{{ 'manage_images_descr' | t }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <div class="text-left">
                    <h5>{{ 'mail_locales' | t }}</h5>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <ul class="list-group">
                    <div
                      class="list-group-item mail-locale"
                      style="cursor: pointer"
                      v-for="locale in mail_template.mail_locales"
                      v-on:click="current_locale = locale"
                      v-bind:class="{ activeLocale: locale.locale === current_locale.locale }"
                    >
                      {{ getLocaleName(locale.locale) }}<span class="fa fa-check-circle-o pull-right mt-1"></span>
                    </div>
                  </ul>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <br />
                  <hr />
                  <div class="form-group">
                    <label>{{ 'add_locale' | t }}</label>
                    <div class="input-group">
                      <select class="form-control selectpicker" v-model="add_locale_value">
                        <option selected="true">{{ '-' }}</option>
                        <option v-for="name in locale_names" :value="getLocaleCode(name)">{{ name }}</option></select
                      ><span class="input-group-btn">
                        <button class="btn btn-outline-primary" @click="addLocale">{{ 'add' | t }}</button></span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <hr />
                  <div class="form-group">
                    <label>{{ 'default_locale' | t }}</label>
                    <select class="form-control" v-model="mail_template.default_locale">
                      <option v-for="locale in mail_template.mail_locales" :value="locale.locale">
                        {{ getLocaleName(locale.locale) }}
                      </option>
                    </select>
                    <p class="mt-1 text-muted">{{ 'default_locale_description' | t }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card mt-3">
            <div class="card-body">
              <div class="form-group">
                <h5>{{ 'placeholders' | t }}</h5>
                <p>{{ 'tracking_placeholders_descr' | t }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading-spinner v-else></loading-spinner>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';
import _ from 'lodash';
import countries from 'i18n-iso-countries';
import isocodes from 'iso-639-1';
import config from '@/config';
import Alerts from '@/utils/alerts';

export default {
  props: ['value'],
  data: function () {
    return {
      language_codes: isocodes.getAllCodes(),
      locale_names: _.sortBy(isocodes.getAllNames()),
      add_locale_value: '-',
      window_height: window.innerHeight,
      local_current_locale: {
        id: null,
        locale: null,
        mail_template_id: null,
        subject: null,
        body: null
      }
    };
  },
  computed: {
    editHeight() {
      let height = this.window_height;
      return height - 325 + 'px';
    },
    current_locale: {
      get() {
        if (this.local_current_locale && this.local_current_locale.locale) {
          return this.local_current_locale;
        } else {
          return this.mail_template.mail_locales[0];
        }
      },
      set(locale) {
        this.local_current_locale = locale;
      }
    },
    mail_template() {
      return this.value;
    }
  },
  methods: {
    save() {
      if (!this.mail_template.id) {
        Api.create('mail_templates', this.mail_template)
          .then(({ data }) => {
            Alerts.success({ title: this.$i18n.t('mail_template_created') });
            this.$router.push({ name: 'mail_templates' });
          })
          .catch(({ errors }) => {
            errors.forEach((error) => {
              Alerts.danger(error);
            });
          });
      } else {
        Api.update('mail_templates', this.mail_template)
          .then(({ data }) => {
            Alerts.success({ title: this.$i18n.t('mail_template_updated') });
            this.$router.push({ name: 'mail_templates' });
          })
          .catch(({ errors }) => {
            errors.forEach((error) => {
              Alerts.danger(error);
            });
          });
      }
    },
    editorInit() {
      require('brace/mode/html');
      require('brace/mode/javascript');
      require('brace/mode/less');
      require('brace/theme/chrome');
    },
    preview() {
      Api.create('mail_template_previews', {
        mail_template: this.mail_template,
        mail_locale: this.current_locale
      })
        .then(({ data }) => {
          this.$refs.preview_modal.open(data.mail.html_body);
        })
        .catch(({ errors }) => {
          Alerts.danger({ title: errors });
        });
    },
    getLocaleName(code) {
      return isocodes.getName(code);
    },
    getLocaleCode(name) {
      return isocodes.getCode(name);
    },
    addLocale() {
      if (this.add_locale_value === '-') {
        return;
      }

      // If already added
      for (let i = 0; i <= this.mail_template.mail_locales.length; i++) {
        if (this.mail_template.mail_locales[i] && this.mail_template.mail_locales[i].locale === this.add_locale_value) {
          return;
        }
      }
      let newLocale = _.cloneDeep(this.current_locale);
      newLocale.locale = this.add_locale_value;
      newLocale.id = null;

      this.mail_template.mail_locales.push(newLocale);
    },
    deleteCurrentLocale() {
      if (this.current_locale.locale == this.mail_template.default_locale) return;

      for (var i = 0; i <= this.mail_template.mail_locales.length; i++) {
        if (this.mail_template.mail_locales[i] == this.current_locale) {
          this.current_locale = null;
          this.mail_template.mail_locales.splice(i, 1);
        }
      }
      this.current_locale = this.mail_template.mail_locales[0];
    }
  },
  async mounted() {
    window.addEventListener('resize', () => {
      this.window_height = window.innerHeight;
    });
  }
};
</script>

<style scoped>
.ace_editor {
  border: 1px solid lightgray;
  border-radius: 3px;
}

.mail-locale .fa {
  display: none;
  color: green;
}

.mail-locale.activeLocale {
  font-weight: bold;
}

.mail-locale.activeLocale .fa {
  display: inline;
}
</style>
